export default "__VITE_ASSET__BHp80j15__"